var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ConfigService {
  constructor() {
    __publicField(this, "config", {});
  }
  async loadConfig(url) {
    try {
      const response = await fetch(url);
      if (response.ok) {
        this.config = await response.json();
      } else {
        console.error("Error loading config:", response.statusText);
      }
    } catch (error) {
      console.error("Error loading config:", error);
    }
  }
  get(key) {
    const value = this.config[key];
    if (value === void 0 && window.DEBUG) {
      console.warn(`Key ${key} not found in config`);
    }
    return value;
  }
}
export {
  ConfigService
};
